import { Phone, Hours } from '~components/AllianceCallService/AllianceCallService';
import Section from '~components/_layout/Section';
import useWindowSize from '~hooks/useWindowSize';

import EmployeeSketch from './images/employee-graphic.inline.svg';

type Props = {
    background?: string;
    hoursInline?: boolean;
    title: string;
};

const NeedHelpRedesign = ({
    background = 'bg-surface-0',
    children,
    hoursInline = false,
    title,
}: React.PropsWithChildren<Props>) => {
    const { isDesktop } = useWindowSize();

    return (
        <Section extraClasses={`${background} text-black px-4 pt-8`}>
            <div className="grid gap-4 grid-cols-4 md:gap-6 md:grid-cols-8 lg:grid-cols-12 max-w-screen-xl mx-auto">
                {!isDesktop && (
                    <h2 className="col-span-4 md:col-span-8 font-bold text-center text-xl md:text-2xl mb-2 md:mb-4">
                        {title}
                    </h2>
                )}
                <div className="col-span-4 md:col-span-8 lg:col-span-10 lg:col-start-2 md:flex md:justify-between md:items-end">
                    <div className="text-center md:text-left md:w-1/2 lg:w-2/3">
                        {isDesktop && (
                            <h2 className="font-bold text-left text-3xl mb-6">{title}</h2>
                        )}
                        <p className="text-base mb-6">{children}</p>
                        <div className="flex flex-col mb-6 xl:flex-row xl:items-center">
                            <div className="mb-4 xl:mb-0 flex flex-col md:flex-row">
                                <Phone
                                    islink={!isDesktop}
                                    classname="font-bold text-base md:text-xl"
                                />
                                <span className="text-base md:text-xl ml-1 lg:mr-2">TTY 711</span>
                            </div>
                            <Hours isinline={hoursInline} classname="text-base" />
                        </div>
                    </div>
                    <div className="w-[282px] h-[144px] mx-auto md:ml-auto md:mr-0">
                        <EmployeeSketch />
                    </div>
                </div>
            </div>
        </Section>
    );
};

export default NeedHelpRedesign;
